
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Familyresortnearyavatmal() {



  const cardData =
  {
    keyword: ' Family Resorts Near Yavatmal',
    heading:  'Woodland Escape: Family Resorts Near Yavatmal ',
    headingDescription: 'Woodland Escape Resort is an excellent family resort near Yavatmal, designed to welcome families of all sizes for comfortable, memorable stays. Nestled amidst green lawns, gentle forested surroundings, and open play spaces, it provides both children and adults plenty of room to relax and enjoy. With cozy cottages, kid-friendly outdoor zones, and calming nature walks for elders, the resort offers a balanced environment where families can connect, unwind and create special memories. Thoughtful hospitality, delicious meals that appeal to all age groups, and a safe, peaceful setting make Woodland Escape Resort near Yavatmal a top choice for a stress-free family getaway.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Family Resorts Near Yavatmal",
      "description": "Discover the best family resorts near Yavatmal offering comfortable stays, recreational activities, and scenic surroundings. These resorts are perfect for families looking for a relaxing retreat with amenities for kids and adults alike, ensuring a memorable vacation experience filled with fun, comfort, and natural beauty."
    },
    {
      "name": "Yavatmal Family Stay Resort",
      "description": "Enjoy a comfortable family stay in Yavatmal at resorts that provide spacious rooms, family-friendly facilities, and convenient access to local attractions. Perfect for families who want to relax, explore, and create lasting memories in a safe and welcoming environment."
    },
    {
      "name": "Affordable Family Resorts Yavatmal",
      "description": "Experience budget-friendly family resorts in Yavatmal without compromising on comfort or amenities. These resorts offer cozy accommodations, recreational options, and scenic surroundings, making them ideal for families looking for value-for-money vacations."
    },
    {
      "name": "Yavatmal Weekend Family Resort",
      "description": "Plan a perfect weekend getaway for your family in Yavatmal. These resorts provide a mix of leisure activities, local sightseeing opportunities, and relaxing environments, ensuring that every weekend is spent creating joyful family memories."
    },
    {
      "name": "Yavatmal Kids Friendly Resort",
      "description": "Choose from Yavatmal resorts designed with kids in mind, offering play areas, kid-friendly activities, and safe environments. Parents can relax while children enjoy engaging games, swimming pools, and creative activities within the resort premises."
    },
    {
      "name": "Yavatmal Family Outing Resort",
      "description": "Plan an exciting family outing at Yavatmal resorts that combine outdoor fun, cozy accommodations, and a variety of activities for all ages. Ideal for day trips or overnight stays that focus on bonding, adventure, and relaxation together as a family."
    },
    {
      "name": "Yavatmal Nature Resort for Families",
      "description": "Reconnect with nature at family resorts in Yavatmal surrounded by lush greenery, rivers, and hills. These resorts offer eco-friendly stays, nature trails, and outdoor activities that encourage families to explore, learn, and enjoy the environment together."
    },
    {
      "name": "Yavatmal Riverside Family Resort",
      "description": "Relax by the river at Yavatmal family resorts offering scenic riverside views, picnic areas, and water-based recreational activities. Perfect for families who love nature, tranquility, and outdoor fun while staying in comfort."
    },
    {
      "name": "Yavatmal Hill Resort for Family",
      "description": "Experience the refreshing ambiance of hill resorts near Yavatmal, featuring panoramic views, cool breezes, and trekking trails suitable for families. These resorts provide a perfect escape for those seeking both adventure and relaxation amidst nature."
    },
    {
      "name": "Yavatmal Family Picnic Resort",
      "description": "Enjoy a perfect family picnic experience at Yavatmal resorts with dedicated picnic spots, gardens, and recreational facilities. These resorts are ideal for day-long outings, offering space for games, barbeques, and family bonding activities."
    },
    {
      "name": "Yavatmal Outdoor Family Resort",
      "description": "Choose resorts in Yavatmal with extensive outdoor spaces for families to enjoy sports, games, and adventure activities. These resorts are designed to ensure children and adults can have fun, stay active, and create unforgettable memories together."
    },
    {
      "name": "Yavatmal Group Family Resort",
      "description": "Perfect for larger families or group vacations, these Yavatmal resorts offer spacious accommodations, communal activity areas, and group-friendly amenities. Enjoy shared experiences, team activities, and group leisure time in a comfortable and welcoming environment."
    },
    {
      "name": "Yavatmal Family Resort Booking",
      "description": "Easily book your preferred family resort in Yavatmal online, securing the best accommodations, activities, and amenities for your stay. Enjoy a seamless and convenient booking experience to ensure a hassle-free family vacation."
    },
    {
      "name": "Yavatmal One Day Family Resort",
      "description": "Plan a one-day family retreat in Yavatmal with resorts that offer day-use facilities, recreational activities, and comfortable amenities. Perfect for families looking to enjoy a fun, relaxing, and memorable day together without staying overnight."
    },
    {
      "name": "Yavatmal Luxury Family Resort",
      "description": "Indulge in luxury family resorts in Yavatmal that provide premium accommodations, fine dining, and extensive recreational options. Ideal for families seeking an upscale vacation experience combining comfort, elegance, and entertainment in a beautiful setting."
    }
  ],
  "tableData": [
    ["- Family Resorts Near Yavatmal", "- Yavatmal Family Stay Resort"],
    ["- Affordable Family Resorts Yavatmal", "- Yavatmal Weekend Family Resort"],
    ["- Yavatmal Kids Friendly Resort", "- Yavatmal Family Outing Resort"],
    ["- Yavatmal Nature Resort for Families", "- Yavatmal Riverside Family Resort"],
    ["- Yavatmal Hill Resort for Family", "- Yavatmal Family Picnic Resort"],
    ["- Yavatmal Outdoor Family Resort", "- Yavatmal Group Family Resort"],
    ["- Yavatmal Family Resort Booking", "- Yavatmal One Day Family Resort"],
    ["- Yavatmal Luxury Family Resort", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Ultimate Family Resort Near Yavatmal",
    "WhyChoosedescription": "Woodland Escape Resort offers a perfect retreat for families near Yavatmal. With its lush surroundings, open green spaces, and a calm natural setting, it provides a safe and enjoyable environment where parents can relax and children can explore and play freely."
  },
  {
    "WhyChooseheading": "Tranquil Nature & Fresh Air",
    "WhyChoosedescription": "Nestled amidst trees, lawns and gentle natural landscapes, the resort gives families a refreshing break from the bustle of city life. The cool breeze, chirping birds and shaded areas make for quiet moments of relaxation, conversation and peaceful connection with nature."
  },
  {
    "WhyChooseheading": "Spacious, Comfortable & Family‑Friendly Accommodation",
    "WhyChoosedescription": "Accommodation at the resort is thoughtfully designed for families — with ample room for kids to move around, comfortable stay options, modern amenities and a safe environment. This ensures that everyone — from grandparents to little ones — enjoys the stay without compromise."
  },
  {
    "WhyChooseheading": "Activities for All Ages & Togetherness",
    "WhyChoosedescription": "Woodland Escape Resort offers a range of family‑friendly activities — nature walks, cycling trails, outdoor games, pond‑side resting spots and open lawns for play. These ensure that children are engaged, parents can join in or relax, and the whole family creates lasting memories together."
  },
  {
    "WhyChooseheading": "Delicious Meals & Shared Dining Experiences",
    "WhyChoosedescription": "Families can enjoy freshly prepared local and multi‑cuisine meals in a comfortable dining setting. The resort makes sure the food is not just good but enjoyable for all age‑groups — offering variety, comfort and convenience so you don’t have to worry about meal logistics."
  },
  {
    "WhyChooseheading": "Designed for Family Weekends & Short Breaks",
    "WhyChoosedescription": "Whether you’re planning a weekend escape, a one‑night stay or a longer family holiday, Woodland Escape Resort is suited for you. The environment, layout, amenities and pace all favour relaxed enjoyment rather than rush — making it just right for families wanting quality time together."
  },
  {
    "WhyChooseheading": "Conveniently Positioned from Yavatmal",
    "WhyChoosedescription": "Situated within a reasonable drive of Yavatmal, Woodland Escape Resort combines accessibility with the feel of a nature hideaway. Less travel time means more time spent having fun, relaxing and bonding — which is perfect for families."
  }
]
























  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a family resort near Yavatmal?",
    answer: "Woodland Escape Resort is one of the best family resorts near Yavatmal, offering a safe, green and serene environment. Families can enjoy quality time together with open lawns, kids’ play zones, outdoor activities and relaxing stay‑options."
  },
  {
    question: "How far is Woodland Escape Resort from Yavatmal city?",
    answer: "The resort is conveniently located within driving distance from Yavatmal, making it perfect for a family day trip or weekend stay. It’s easily accessible while still giving a peaceful getaway feel."
  },
  {
    question: "What facilities are available for families at Woodland Escape Resort?",
    answer: "The resort features spacious lawns, dedicated children’s play areas, outdoor games, picnic spots, nature walks and comfortable accommodations. It’s designed to ensure fun and relaxation for all family members."
  },
  {
    question: "Is Woodland Escape Resort suitable for families with kids and senior members?",
    answer: "Yes! Woodland Escape Resort is very family‑friendly with safe surroundings, open spaces, and amenities ideal for children, parents and grandparents alike. Everyone can enjoy their stay."
  },
  {
    question: "Does the resort provide meals and refreshments for families?",
    answer: "Yes. Woodland Escape Resort offers freshly prepared meals, snacks and beverages. Family packages can include lunch, refreshments and sometimes dinner — making your stay comfortable and hassle‑free."
  },
  {
    question: "How can we book our family visit or stay at Woodland Escape Resort near Yavatmal?",
    answer: "Booking is easy — you can call or WhatsApp the reservations team, or visit the official website. Advance booking is recommended for weekends and holidays to secure your preferred date and room type."
  }
];

const testimonials = [
  {
    name: "Mr. Vinod & Family, Yavatmal",
    text: "Our family stay at Woodland Escape Resort was amazing! The surroundings were peaceful, the kids enjoyed the play area and open space, and the food was excellent. Truly one of the best family resorts near Yavatmal."
  },
  {
    name: "Ms. Shilpa & Family, Yavatmal",
    text: "Woodland Escape Resort is perfect for a family getaway. The green lawns, fun activities for kids and relaxing environment made our weekend memorable. Highly recommended for families near Yavatmal!"
  }
];






























      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Family Resorts Near Yavatmal",
  "image": "https://woodlandescape.com/assets/images/yavatmal-family-resort.jpg",
  "description": "Discover the best family resorts near Yavatmal at Woodlandescape Resort. Perfect for weekend family getaways, kid-friendly activities, nature stays, riverside relaxation, and hilltop retreats.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "42"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1599",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/family-resorts-yavatmal"
  }
};




  return (
    <div>
<Helmet>
  <title>Family Resorts Near Yavatmal | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Explore top family resorts near Yavatmal at Woodlandescape Resort. Ideal for family outings, weekend stays, kid-friendly activities, nature retreats, riverside relaxation, and hill resorts." 
  />
  <meta 
    name="keywords" 
    content="Family Resorts Near Yavatmal, Yavatmal Family Stay Resort, Affordable Family Resorts Yavatmal, Yavatmal Weekend Family Resort, Yavatmal Kids Friendly Resort, Yavatmal Family Outing Resort, Yavatmal Nature Resort for Families, Yavatmal Riverside Family Resort, Yavatmal Hill Resort for Family, Yavatmal Family Picnic Resort, Yavatmal Outdoor Family Resort, Yavatmal Group Family Resort, Yavatmal Family Resort Booking, Yavatmal One Day Family Resort, Yavatmal Luxury Family Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/46.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Familyresortnearyavatmal;